import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import marked from 'marked';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class MarkdownService {
  private renderer = new marked.Renderer();

  constructor(private http: HttpClient) {
    this.renderer.heading = (text: string, level: number) => {
      if(level === 1){
        return `<p class="grey4 itemTerminosCondicionesTitulo">${text}</p><br>`;
      }
      return `<h${level} class="md-h${level}">${text}</h${level}>`;
    };

    this.renderer.paragraph = (text: string) =>
      `<p class="grey4 itemTerminosCondicionesBeneficiosCategorias">${text}</p><br>`;
    this.renderer.link = (href, title, text) => {
            const url = href ?? '';

            const isExternal = url.startsWith('http');

            if (isExternal) {
              return `<a href="${url}" class="textBancaInternet2 blue1 bold" target="_blank">${text}</a>`;
            }

            return `<a href="${url}" class="textBancaInternet2 blue1 bold">${text}</a>`;
      };
  }

  loadMarkdown(path: string): Observable<string> {
    return this.http.get(path, { responseType: 'text' }).pipe(
      map((md) => marked.parse(md, { renderer: this.renderer }))
    );
  }
}
